import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        pending: {
            redirectButtonText: string;
            redirectUrl: string;
        };
    };
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    schoolNamePlaceholder: 'University / College name',
    firstNamePlaceholder: 'First name',
    lastNamePlaceholder: 'Last name',
    emailAddressPlaceholder: 'Email address (Personal email recommended)',
    infoShared1: 'Information entered here will be used for verification purposes. The information will be shared with Dockers. ',
    infoShared2: ' ',
    tryAgain: 'TRY AGAIN',
    step: {
        success: {
            redirectButtonText: 'CONTINUE',
            redirectUrl: ' https://www.dockers.com',
            verificationOnly: '\nSheerID handles verification only.\nNow that you\'ve been approved, please direct all questions about the\npromotion terms and/or code use to Dockers customer service.\n',
        },
        pending: {
            redirectButtonText: 'CONTINUE TO DOCKERS',
            redirectUrl: ' https://www.dockers.com',
            titleReview: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status.<br><br> This process may take up to 20 minutes.',
        },
        docUpload: {
            title: 'We need some more info',
            howDoesVerifyingWorkDetails: 'Document review is handled by SheerID, a trusted partner who specializes in verifying students.<br><br>\nDocuments are used only for verifying your student status is current and will be permanently deleted after\neview is finalized. They will not be shared with Dockers.',
        },
        personalInfo: {
            subtitle: 'Verify you\'re a student at a degree-granting college or university.',
            howDoesVerifyingWorkDetails: 'To be eligible for this offer, you must currently be enrolled in a degree-granting, accredited school of higher\neducation.<br><br>Dockers uses SheerID, a trusted partner, to verify that you are a current student.\nSheerID only collects information that assists in verifying your eligibility. Additional information or documentation\nmay be requested.',
        },
    },
};
